<template>
<v-container fluid>
    <v-layout row wrap>
        <v-layout row wrap>
            <v-flex xs12>
                <v-subheader class="headline mt-2">{{ this.$route.name  }}</v-subheader>
            </v-flex>
        </v-layout >
        <v-container>
            <v-layout row>
                <v-flex xs12>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-progress-linear :active="isInProgress" slot="progress" color="blue" indeterminate></v-progress-linear>
                    <v-data-table
                            :headers="mainHeaders"
                            :items="mainItems"
                            :search="search"
                            item-key="phone"
                            class="elevation-1">
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td class="text-xs">{{ props.item.phone }}</td>
                                <td class="text-xs">
                                    <v-btn v-if="props.item.status === 'active'" @click="updUserStatus(props.item, 'deactive')" color="success">Active</v-btn>
                                    <v-btn v-else @click="updUserStatus(props.item, 'active')" color="error">Deactive</v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </v-layout>
</v-container>
</template>

<script>

export default {
    mounted() {
        this.getUserList()
    },

    data () {
        return {
            search: '',
            newStatus: '',
            isInProgress: false,
            mainHeaders: [
                { text: 'Телефон', value: 'phone' },
                { text: 'Статус',  value: 'status' }
            ],
            mainItems: [],
        }
    },

    methods: {
        getUserList() {
            this.isInProgress = true
            this.$store.dispatch('GET_USER_LIST')
            .then( (users) => {
                this.mainItems = users.filter( u => u.phone)
                this.isInProgress = false
            })
            .catch( (err) => {
                console.log(err)
                this.isInProgress = false
            })
        },

        updUserStatus(item, newStatus) {
            this.$store.dispatch('UPD_USER_STATUS', {
                phone: item.phone,
                newStatus: newStatus
            })
            .then( (result) => {
                item.status = newStatus
            })
            .catch( (err) => {
                console.log(err)
            })
        },
    }
}

</script>
